import Vue from 'vue';
import Vuex from 'vuex';

import usersModule from './modules/users';
import endpointsModule from './modules/endpoints';
import usageModule from './modules/usage';
import pageLoader from './modules/pageLoader';

// transcoding
import jobsModule from './modules/transcoding/jobs';
import jobsOverviewModule from './modules/transcoding/overviewReports';
import jobsUsageReportsModule from './modules/transcoding/usageReports';
import encodingProfilesModule from './modules/transcoding/profiles';
import watchFoldersModule from './modules/transcoding/watchfolders';
import channelDistributionsModule from './modules/transcoding/channelDistributions';
import dvrChannelsModule from './modules/dvr';
import localizationModule from './modules/localization';
import ipModule from './modules/ip';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users: usersModule,
    endpoints: endpointsModule,
    usage: usageModule,
    jobs: jobsModule,
    jobsOverview: jobsOverviewModule,
    jobsUsage: jobsUsageReportsModule,
    pageLoader,
    encodingProfiles: encodingProfilesModule,
    watchFolders: watchFoldersModule,
    channelDistribs: channelDistributionsModule,
    ipCheck: ipModule,
    dvr: dvrChannelsModule,
    localization: localizationModule,
  },
});
